import _ from 'lodash';
import { jwtDecode } from 'jwt-decode';

const safeJsonParse = (str) => {
  try {
    return [true, JSON.parse(str)];
  } catch (err) {
    return [false, str];
  }
};

export const login = async ({ email, password }, queryParams) => {
  const { 'redirect_uri': redirectURI, 'redirect_version': redirectVersion, ...rest } = queryParams;
  const response = await fetch(`${process.env.REACT_APP_GATEWAY_SERVICE_URL}/api/sso/token`, {
    method: 'POST',
    cache: 'no-cache',
    body: JSON.stringify({ email, password, ...rest }),
    headers: { 'Content-Type': 'application/json' },
  });

  if (response.status === 200) {
    const { idToken, refreshToken } = await response.json();
    const { exp, iat } = jwtDecode(idToken);
    // based in the redirect version we add a '?' or '#' for backward compability
    const URIToken = redirectVersion === '2' ? '?' : '#';
    return { success: true, action: 'redirect', redirectTo: `${redirectURI}${URIToken}access_token=${idToken}&expires_in=${exp - (iat || 0)}&refresh_token=${refreshToken}` };
  }

  const [isJson, result] = await response.text().then(safeJsonParse);
  if (!isJson) {
    return { success: false, message: result };
  }

  if (result.authorizedByIDS) {
    return { success: true, action: 'migrate' };
  }

  return { success: false, ...result };
};

export const forgot = async ({ email }) => {
  const response = await fetch(`${process.env.REACT_APP_GATEWAY_SERVICE_URL}/api/sso/reset`, {
    method: 'POST',
    cache: 'no-cache',
    body: JSON.stringify({ email, mailFormatType: 'rvs' }),
    headers: { 'Content-Type': 'application/json' },
  });

  return response.status === 200;
};
export const getLoginMessageConfig = async () => {

  const url = `${process.env.REACT_APP_APP_URL}${process.env.REACT_APP_PARSE_PATH}/classes/Config?${new URLSearchParams([['where', '{"name":"sso-login-message"}']])}`;
  const response = await fetch(url, {
    method: 'GET',
    cache: 'no-cache',
    headers: {
      'X-Parse-Application-Id': process.env.REACT_APP_PARSE_APPID,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then((res) => res.json());

  const loginMessageConfigString = _.get(response, 'results[0].value');

  return loginMessageConfigString
    ? JSON.parse(loginMessageConfigString)
    : { enabled: false };
};
